import React, { FC } from 'react';
import { Box, Skeleton } from '@mui/material';
import { useStyles, Colors } from '@sweatpals/react-ui-kit';
import { upgradeTicketFormStyles } from './upgrade-ticket-form.styles';

const UpgradeTicketFormSkeleton: FC = () => {
	const styles = useStyles(upgradeTicketFormStyles);

	return (
		<Box sx={styles.root}>
			<Box sx={styles.content}>
				<Box sx={styles.body}>
					<Box sx={styles.formBody}>
						<Box sx={{ width: { xs: '100%', md: '320px' }, display: 'flex', flexDirection: 'column' }}>
							<Box sx={{ ...styles.eventInfo, borderRadius: '8px 8px 0 0' }}>
								<Skeleton
									sx={{ width: '70px', height: '70px', borderRadius: '12px', backgroundColor: Colors.white_a30 }}
									variant="rectangular"
								/>
								<Box sx={{ gap: '4px', display: 'flex', flexDirection: 'column', flex: 1 }}>
									<Skeleton
										sx={{ width: '138px', height: '20px', borderRadius: '20px', backgroundColor: Colors.white_a30 }}
										variant="rectangular"
									/>
									<Skeleton
										sx={{ width: '98px', height: '20px', borderRadius: '20px', backgroundColor: Colors.white_a30 }}
										variant="rectangular"
									/>
								</Box>
							</Box>
							<Box position="relative" zIndex={1}>
								<svg
									style={{
										height: '1px',
										width: '100%',
										position: 'absolute',
										bottom: 0,
										left: 0,
										strokeWidth: '1px',
									}}
								>
									<line x1="0" y1="0" x2="100%" y2="0" stroke="#FFFFFF1A" strokeDasharray="6 6" />
								</svg>
							</Box>
							<Box sx={styles.orderSummary}>
								<Box
									sx={{
										p: '0 12px 1px',
										display: 'flex',
										flexDirection: 'column',
										gap: '18px',
									}}
								>
									<Box display="flex" justifyContent="space-between" height="14px">
										<Skeleton
											sx={{
												height: '100%',
												width: '98px',
												borderRadius: '20px',
												backgroundColor: Colors.white_a30,
											}}
											variant="rectangular"
										/>
										<Skeleton
											sx={{
												height: '100%',
												width: '36px',
												borderRadius: '20px',
												backgroundColor: Colors.white_a30,
											}}
											variant="rectangular"
										/>
										<Skeleton
											sx={{
												height: '100%',
												width: '36px',
												borderRadius: '20px',
												backgroundColor: Colors.white_a30,
											}}
											variant="rectangular"
										/>
									</Box>
									<Box sx={{ height: '1px', width: '100%', backgroundColor: Colors.white_a10 }} />
									<Box display="flex" justifyContent="space-between" height="14px">
										<Skeleton
											sx={{
												height: '100%',
												width: '98px',
												borderRadius: '20px',
												backgroundColor: Colors.white_a30,
											}}
											variant="rectangular"
										/>
										<Skeleton
											sx={{
												height: '100%',
												width: '36px',
												borderRadius: '20px',
												backgroundColor: Colors.white_a30,
											}}
											variant="rectangular"
										/>
									</Box>
									<Box display="flex" gap="4px" flexWrap="wrap">
										<Skeleton
											sx={{ height: '8px', width: '36px', borderRadius: '8px', backgroundColor: Colors.white_a30 }}
											variant="rectangular"
										/>
										<Skeleton
											sx={{ height: '8px', width: '112px', borderRadius: '8px', backgroundColor: Colors.white_a30 }}
											variant="rectangular"
										/>
										<Skeleton
											sx={{ height: '8px', width: '67px', borderRadius: '8px', backgroundColor: Colors.white_a30 }}
											variant="rectangular"
										/>
										<Skeleton
											sx={{ height: '8px', width: '67px', borderRadius: '8px', backgroundColor: Colors.white_a30 }}
											variant="rectangular"
										/>
										<Skeleton
											sx={{ height: '8px', width: '179px', borderRadius: '8px', backgroundColor: Colors.white_a30 }}
											variant="rectangular"
										/>
										<Skeleton
											sx={{ height: '8px', width: '136px', borderRadius: '8px', backgroundColor: Colors.white_a30 }}
											variant="rectangular"
										/>
									</Box>
								</Box>
							</Box>
						</Box>
						<Box
							sx={{
								flex: { xs: 'unset', md: 1 },
								overflowX: 'hidden',
								overflowY: { xs: 'unset', md: 'auto' },
							}}
						>
							<Box sx={styles.form}>
								<Box display="flex" flexDirection="column" gap="31px">
									<Box display="flex" flexDirection="column" gap="8px">
										<Skeleton
											sx={{ height: '20px', width: '210px', borderRadius: '12px', backgroundColor: Colors.white_a30 }}
											variant="rectangular"
										/>
										<Skeleton
											sx={{ height: '14px', width: '100%', borderRadius: '12px', backgroundColor: Colors.white_a20 }}
											variant="rectangular"
										/>
									</Box>
									<Box display="flex" flexDirection="column" gap="11px">
										<Skeleton
											sx={{ height: '14px', width: '98px', borderRadius: '12px', backgroundColor: Colors.white_a20 }}
											variant="rectangular"
										/>
										<Skeleton
											sx={{ height: '50px', width: '100%', borderRadius: '12px', backgroundColor: Colors.white_a5 }}
											variant="rectangular"
										/>
									</Box>
									<Box display="flex" flexDirection="column" gap="11px">
										<Skeleton
											sx={{ height: '14px', width: '98px', borderRadius: '12px', backgroundColor: Colors.white_a20 }}
											variant="rectangular"
										/>
										<Skeleton
											sx={{ height: '50px', width: '100%', borderRadius: '12px', backgroundColor: Colors.white_a5 }}
											variant="rectangular"
										/>
									</Box>
									<Box display="flex" justifyContent="center">
										<Skeleton
											sx={{ height: '50px', width: '165px', borderRadius: '50px', backgroundColor: Colors.white_a20 }}
											variant="rectangular"
										/>
									</Box>
								</Box>
							</Box>
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export default UpgradeTicketFormSkeleton;
